import { formatDisplayLabel } from './camelCaseLabel';
import { isValidLeaveDate } from './leaveFilters';

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

/** Whole calendar days from today until the WFH start date (0 = same day). */
export function wfhNoticeDays(today: string, fromDate: string): number | null {
  if (!isValidLeaveDate(today) || !isValidLeaveDate(fromDate)) return null;
  if (!DATE_ONLY.test(today) || !DATE_ONLY.test(fromDate)) return null;
  const todayMs = Date.parse(`${today}T00:00:00Z`);
  const fromMs = Date.parse(`${fromDate}T00:00:00Z`);
  if (Number.isNaN(todayMs) || Number.isNaN(fromMs)) return null;
  return Math.round((fromMs - todayMs) / 86400000);
}

export function wfhAdvanceNoticeMessage(minimumNoticeDays: number): string {
  return `WFH must be submitted at least ${minimumNoticeDays} day(s) in advance.`;
}

/**
 * Advance notice from the employee's WFH policy. The server checks the same
 * rule; this only stops the request before it is sent.
 */
export function wfhAdvanceNoticeViolation(input: {
  minimumNoticeDays: number | null | undefined;
  fromDate: string;
  today: string;
}): string | null {
  const minimum = Number(input.minimumNoticeDays);
  if (!Number.isFinite(minimum) || minimum <= 0) return null;
  const notice = wfhNoticeDays(input.today, input.fromDate);
  if (notice == null || notice >= minimum) return null;
  return wfhAdvanceNoticeMessage(minimum);
}

type WfhDurationSource = {
  durationName?: string | null;
  sessionName?: string | null;
  isHalfDay?: boolean | null;
};

/**
 * Full Day / Half Day label from the session catalog names the API returns,
 * e.g. "Full Day" or "Half Day (First Half)". Null when the API sent none.
 */
export function formatWfhDurationLabel(
  source: WfhDurationSource | null | undefined,
): string | null {
  const duration = source?.durationName?.trim();
  const session = source?.sessionName?.trim();
  if (!duration && !session) return null;
  if (!duration) return formatDisplayLabel(session as string);
  if (source?.isHalfDay && session && session !== duration) {
    return `${formatDisplayLabel(duration)} (${formatDisplayLabel(session)})`;
  }
  return formatDisplayLabel(duration);
}
